import productActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
import _ from 'lodash';
import objectifyTags from './objectifyTags';

const options = {
  asyncReducers: {
    success: (state: any, action: any) => {
      let products = _.get(action, 'response.products', []);
      objectifyTags(products);

      products = _.orderBy(
        products,
        ['tags.type', 'tags.uiGroup', 'tags.uiOrderInGroup', 'name'],
        ['desc', 'desc', 'asc', 'asc'],
      );

      return {
        ...state,
        products,
      };
    },
  },
};

export default createAsyncRequestReducer(
  productActionTypes.FETCH_PRODUCTS,
  options,
);
